import { Component, OnInit } from '@angular/core';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import {
  NotificationApiService,
  NotificationEventInterface,
} from 'src/app/services/notification-api/notification-api.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { LoginService } from 'src/app/services/login/login.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { LevelService } from 'src/app/services/lobby/level.service';
import { PiggyBankService } from 'src/app/services/piggybank/piggybank.service';
import { Platform } from '@ionic/angular';
import { NotificationHandlerService } from 'src/app/services/notification-handler/notification-handler.service';
@Component({
  selector: 'app-server-notification'
})
export class ServerNotificationComponent implements OnInit {
  public Que = [];
  public activeNotifications = 0;
  private inGameBalanceUpdateDelay: any;
  levelUpDelay: any;
  private notificationHaltTimeout: any;
  private isNotificationHalted = true;
  private showNotificationsTimeout: any;

  constructor(
    private readonly levelService: LevelService,
    private configService: ConfigService,
    private notificationApiService: NotificationApiService,
    private userSession: UserSessionService,
    private accountBalanceService: AccountBalanceService,
    private globalErrorHandlerService: GlobalErrorHandlerService,
    // private jackpotCounter: JackpotCounterProvider,
    private eventsService: EventsService,
    private loginService: LoginService,
    private authenticationService: AuthenticationService,
    private notificationHandler: NotificationHandlerService,
    private piggyService: PiggyBankService,
    private platform:Platform,
    private navigator: Navigator //private mainProvider : MainProvider
  ) { }

  ngOnInit() {
    //initial delay to resume notifications after 7 seconds
    this.notificationHaltTimeout = setTimeout(() => {
      this.resumeNotifications();
    }, 7000);

    this.notificationHandler.isNotificationHalted$.subscribe((isHalted) => {
      if (isHalted) {
        this.haltNotifications();
      } else {
        this.resumeNotifications();
      }
    });

    this.subscribeToNotifications();
    this.eventsService.subscribe('event:notifications:safeStart', () => {
      this.showNotifications();
    });
    this.eventsService.subscribe('event:authentication:logout', () => {
      this.Que = [];
      this.activeNotifications = 0;
    });
    this.levelUpDelay = this.configService.getConfig().FEATURE_LEVEL_UP_POPUP_DELAY ? this.configService.getConfig().FEATURE_LEVEL_UP_POPUP_DELAY : 3;
    this.inGameBalanceUpdateDelay = this.configService.getConfig().FEATURE_GAME_BALANCE_DELAY ? this.configService.getConfig().FEATURE_GAME_BALANCE_DELAY : 5;
  }


  // Method to halt notifications
  haltNotifications() {
    this.isNotificationHalted = true;
    
    // Clear any existing timeout
    if (this.notificationHaltTimeout) {
      clearTimeout(this.notificationHaltTimeout);
      this.notificationHaltTimeout = null;
    }
    
    // Clear any pending showNotifications timeout
    if (this.showNotificationsTimeout) {
      clearTimeout(this.showNotificationsTimeout);
      this.showNotificationsTimeout = null;
    }
  }

  // Method to resume notifications
  resumeNotifications() {
    // Clear any existing timeout
    if (this.notificationHaltTimeout) {
      clearTimeout(this.notificationHaltTimeout);
      this.notificationHaltTimeout = null;
    }
    
    this.isNotificationHalted = false;
    
    // Start showing notifications immediately if there are any in the queue
    if (this.Que.length && !this.activeNotifications) {
      this.showNotifications();
    }
  }

  subscribeToNotifications() {

    this.notificationApiService
      .listen()
      .subscribe(async (e: NotificationEventInterface) => {
        try {
        } catch (e) { }
        switch (e.type) {
          case 'PUSH_APP_SESSION_STATS':
            break;
          case 'LOYALTY_NEW_TIER':
            let newLevel = e.customField5;
            let awardPoints = e.parametersMap.awardPoints;
            let new_feature = e.parametersMap.unlocked_feature;
            setTimeout(() => {
              this.levelService.checkLevel(Number(newLevel), awardPoints, new_feature);
            }, this.levelUpDelay * 1000);
            break;
          case 'MILESTONE_AWARD':
            break;
          case 'PREMIUM_PURCHASE_AVAILABLE':
            this.eventsService.publish("event:call:getpremium");
            break;
          case 'LEADERBOARD_GRANT':
            this.addNotificationToQue(e);
            break;
          case 'LEADERBOARD_GRANT_FOR_NON_LEADERS':
            this.addNotificationToQue(e);
            break;
          case 'LOYALTY_TIER_WILL_EXPIRY':
            break;
          case 'MARKETING_OFFER':
            this.addNotificationToQue(e);
            break;
          case 'MARKETING_MESSAGE':
            this.addNotificationToQue(e);
            break;
          case 'IDSCAN_IDENTIFICATION_CALLBACK':
            this.sendIDNowResposne(e);
            break;
          case 'RESERVED_BIG_WIN':
            break;
          case 'MARKETING_PROMO':
            break;
          case 'BAGDE_AWARDED':
            break;
          case 'BALANCE':
            //Below Event will Kick in only when Game Component Initialized
            this.eventsService.publish("event:inactivity:reset");
            this.controlledBalanceCallFromClient(e);
            break;
          case 'LOGOUT':
            this.globalErrorHandlerService.handleError({
              code: 'INVALID_SESSION_TOKEN',
            });
            this.eventsService.publish("event:tracker:logout");
            break;
          case 'PREVIOUS_DISCONNECTION':
            this.userSession.isAuthenticated().then(isAuthenticated => {
              if (isAuthenticated) {
                if ('customField2' in e) {
                  let disconnectionTimeframe = e['customField2'];
                  let disconnectionTimeframeAllowed =
                    this.configService.getConfig().DISCONNECT_TIME_ALLOWED ||
                    5000;

                  if (
                    ~~disconnectionTimeframe > ~~disconnectionTimeframeAllowed
                  ) {
                    this.globalErrorHandlerService.handleError({
                      code: 'INVALID_DISCONNECT_TIME_ALLOWED',
                    });
                  }
                }
              } else {
                console.log('already unauthenticated');
              }
            });
            break;
          case 'JACKPOT':
            let gameTypeId = e.parametersMap ? e.parametersMap.gameTypeIds : '';
            let currency = e.parametersMap ? e.parametersMap.currency : '';
            let jackpotID = e.customField3 ? e.customField3 : '';
            let siteJackpotID =
              this.configService.getConfig().FEATURE_JACKPOT_ID;

            if (jackpotID == siteJackpotID && gameTypeId === '333') {
              if (currency == this.configService.getConfig().DEFAULT_CURRENCY) {
                let data: any = {
                  amount: e.parametersMap.amount,
                  currency: currency,
                };
                //this.jackpotCounter.sendCounterValue(data);
              }
            }
            break;
          case 'JACKPOT_HIT':
            break;
          case 'PIGGY_BREAK_AVAILABLE':
            if (e.parametersMap) {
              this.piggyService.setPiggyStatus(e.parametersMap.piggyStatus);
            }
            break;
          case 'APPROVED_DEPOSIT':
            this.pushPlayerDepositSuccess(e);
            break;
          case 'FAILED_DEPOSIT':
            this.eventsService.publish('event:deposit:failed', e);
            break;
          case 'PLAYER_CONVERSION':
            this.pushPlayerConversionEvent(e);
            break;
          case 'PLAYER_BET':
            this.pushPlayerBetEvent(e);
            break;
          case 'REGISTRATION_COMPLETE':
            this.pushPlayerRegistrationComplete();
            break;
          case 'IOS_RATING_ALERT':
            this.eventsService.publish('event:load:apprate');
            break;
          case 'LOGIN':
            this.pushPlayerLogin();
            break;
          case 'PUSH_GAME_SESSION_STATS':
            console.log('netWin : ' + e.parametersMap.netWinAmount);
            this.sendGameNetWinData(e);
            break;
          case 'ALERT':
            return this.navigator.navigateTo('AlertNotificationComponent',
            { customModalClass: 'crown-modal' },
             {
               data : {
                content: e.text,
                title: e.title,
                htmlText: e.htmlText,
                notificationImage: e.notificationImage,
                notificationLink: e.notificationLink,
                timeout: 30000,
                extraData: e.extraData
               }
            });
          case 'MESSAGE':
            return this.navigator.navigateTo('AlertNotificationComponent',
            { customModalClass: 'crown-modal' },
             {data : {
              content: e.text,
              title: e.title,
              htmlText: e.htmlText,
              notificationImage: e.notificationImage,
              notificationLink: e.notificationLink,
              timeout: 30000,
             }
              });
          case 'INVALIDATE_PREVIOUS_CONNECTION':
          {
            if(this.platform.is('mobileweb') || this.platform.is('desktop')){
              this.navigator.openPopover('GlobalErrorBlockSitePopover', e.text.trim(), "block-site-popover",false, true, true, -1, 'cover', false);
            }
            break;
          }
          case 'MANUAL':
          default:
            this.handleGenericEvents(e)
            break;
        }
      });
  }

  addNotificationToQue(e: NotificationEventInterface) {
    this.Que.push(e);
    this.eventsService.publish("event:notifications:start");
  }
  handleGenericEvents(e) {
    this.eventsService.publish("event:notifications", e);
  }
  showNotifications() {
    const justSignedUp = sessionStorage.getItem('signed-up') === 'true';
    if (justSignedUp || this.isNotificationHalted) {
      return;
    }
    
    // Clear any existing timeout
    if (this.showNotificationsTimeout) {
      clearTimeout(this.showNotificationsTimeout);
    }
    
    // Set new timeout and store reference to it
    this.showNotificationsTimeout = null; // Clear reference once executed
    if (this.Que.length) {
      let e = this.Que[0];
      this.Que.shift()
      this.showNotification(e);
    }
  }

  showNotification(e) {
    e.onCloseFunc = this.nextNotification;
    switch(e.type){
      case 'MARKETING_OFFER':
      case 'MARKETING_MESSAGE':
        this.showMarketingNotification(e);
        break;
      case 'LEADERBOARD_GRANT':
      case 'LEADERBOARD_GRANT_FOR_NON_LEADERS':
        this.showLeaderboardNotification(e);
        break;
    }
    this.activeNotifications = 1;
  }

  showMarketingNotification(e){
    this.navigator.openPopover(
      'PopoverMarketingComponent',
      e,
      'standard-popover marketing-notification',
      true,
      true,
      true
    );

    this.eventsService.publish("event:marketingpopup:active");
  }

  showLeaderboardNotification(e){
    this.navigator.navigateTo('LeaderboardEndCongratsPopupComponent', { customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true }, { data: e });
  }
  showNextNotification() {
    if (this.Que.length) {
      this.eventsService.publish("event:notifications:forceStart");
    } else {
      this.eventsService.publish("event:marketingpopup:inactive");
    }
  }
  nextNotification = (emmiter = null) => {
    this.eventsService.publish("event:marketingpopup:inactive");
    this.activeNotifications = 0;
    if (emmiter === 'closeButton') {
      this.showNextNotification();
    }
  };

  sendGameStatsResponse(e) {
    const previousBalance = this.accountBalanceService.startingBalance;
    const currentBalance = e.parametersMap.amount;
    let netWinAmount: any = currentBalance - previousBalance;
    netWinAmount = String(netWinAmount.toFixed(2));
    //This looks not proper fix for STRDST-473..as below event is purely used for NetWin information
    //this.eventsService.publish('event:GameStats:Response', netWinAmount);
  }

  sendIDNowResposne(e) {
    console.log('ID NOW Response');
    console.log(e.customField2);
    this.eventsService.publish('event:IDNow:CallBack', e.customField2)
  }

  sendGameNetWinData(e) {
    console.log('Game Stats Response ' + e.type);
    console.log('--Game Stats netWinAmount--', e.parametersMap.netWinAmount);
    this.eventsService.publish('event:GameStats:Response', e.parametersMap.netWinAmount);
  }

  pushPlayerDepositSuccess(event) {
    let data;
    let hasMap: boolean = false;
    if ("parametersMap" in event) {
      data = event.parametersMap;
      hasMap = true;
    }
    let depositEventData = {
      customer_id: this.userSession.getCustomerId() ? this.userSession.getCustomerId() : "",
      amount: (hasMap && "amount" in data) ? data.amount : "",
      paymentMethod: (hasMap && "payment_type_code" in data) ? data.payment_type_code : "",
      transaction_id: (hasMap && "id" in data) ? data.id : "",
      count: (hasMap && "count" in data) ? data.count : "",
    }
    console.log('APPROVED_DEPOSIT---', depositEventData);
    setTimeout(() => this.eventsService.publish('event:deposit', depositEventData), 2000);
  }

  pushPlayerConversionEvent(event) {
    let conversionEventData: AffiliateTrackerCallbackParams = {
      customer_id: this.loginService.getCustomerID(),
      registration_complete: "1",
      deposit: "1",
      bet_placed: "1"
    }
    setTimeout(() => this.eventsService.publish('event:conversion:set', conversionEventData), 2000);
  }

  pushPlayerBetEvent(event) {
    let data;
    let hasMap: boolean = false;
    if ("parametersMap" in event) {
      data = event.parametersMap;
      hasMap = true;
    }
    let betEventData: AffiliateTrackerCallbackParams = {
      customer_id: this.loginService.getCustomerID(),
      "game_provider": (hasMap && "game_provider" in data) ? data.game_provider : "",
      "restricted_amount": (hasMap && "restricted_amount" in data) ? data.restricted_amount : "",
      "wager_amount": (hasMap && "wager_amount" in data) ? data.wager_amount : "",
      "wager_trx_id": (hasMap && "wager_trx_id" in data) ? data.wager_trx_id : "",
      "deposit_count": (hasMap && "deposit_count" in data) ? data.deposit_count : "",
      "withdrawal_count": (hasMap && "withdrawal_count" in data) ? data.withdrawal_count : "",
      "total_deposit": (hasMap && "total_deposit" in data) ? data.total_deposit : "",
      "total_withdrawal": (hasMap && "total_withdrawal" in data) ? data.total_withdrawal : "",
      "game_name": (hasMap && "game_name" in data) ? data.game_name : "",
    }
    setTimeout(
      () => this.eventsService.publish('event:bet:server', betEventData), 1000);

  }

  pushPlayerRegistrationComplete() {
    let registrationData: AffiliateTrackerCallbackParams = {
      customer_id: this.authenticationService.customer.customerId
    }

    setTimeout(
      () => this.eventsService.publish('event:signupcomplete', registrationData), 1000);
  }
  pushPlayerLogin() {
    if (this.authenticationService?.customer?.customerId) {
      let loginData = {
        customer_id: this.authenticationService?.customer?.customerId
      }
      setTimeout(
        () => this.eventsService.publish('event:login', loginData), 1000);
    } else {
      setTimeout(() => this.eventsService.publish('event:login', {}), 1000);
    }
  }
  controlledBalanceCallFromClient(e) {

    if (e.parametersMap.transactionType === "LOYALTY") {
      this.levelService.updateProgressFromClient(e);
    } else {
      if (e.parametersMap.actionType) {
        const actionType = e.parametersMap.actionType;
        switch (actionType) {
          case 'ROCKET_CREDIT_GRANT':
            setTimeout(() => {
              this.accountBalanceService.updateBalanceFromNotification(e);
              // this.levelService.checkLevel();
              this.sendGameStatsResponse(e);
            }, 30000);
            break;
          case 'HOURLY_CREDIT_GRANT':
            setTimeout(() => {
              this.accountBalanceService.updateBalanceFromNotification(e);
              // this.levelService.checkLevel();
              this.sendGameStatsResponse(e);
            }, 2000);
            break;
          default:
            this.accountBalanceService.updateBalanceFromNotification(e);
            // this.levelService.checkLevel();
            this.sendGameStatsResponse(e);
            break;
        }
      }
      if (e.parametersMap.transactionType) {
        const transactionType = e.parametersMap.transactionType;
        switch (transactionType) {
          case 'ROUND_WIN':
            {
              this.eventsService.publish('event:bet:coinPiggyAnimation')
              setTimeout(() => {
                this.accountBalanceService.updateBalanceFromNotification(e);
                this.sendGameStatsResponse(e);
              }, this.inGameBalanceUpdateDelay * 1000);
              break;
            }
        }
      }
    }

  }


}
